module.exports = __webpack_public_path__ + "static/media/es-designer.82ed2ff.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/video/es-designer.mp4
// module id = dsJG
// module chunks = 1